import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { checkFCMCompatibility } from "@/utils/browserCompatibility";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};


export const initFirebaseMessaging = () => {

  if (typeof window !== "undefined") {

  const compatibility = checkFCMCompatibility();

  if (!compatibility.isCompatible) {
    console.log("Browser not compatible with Firebase Cloud Messaging:", compatibility.errors);
    return {
      isCompatible: false,
      errors: compatibility.errors,
      messaging: null,
      requestPermission: () => Promise.resolve(null),
      refreshToken: () => Promise.resolve(null),
      onMessageListener: () => Promise.resolve({}),
    };
  }

  const messaging = getMessaging(initializeApp(firebaseConfig));

    return {
      isCompatible: true,
      errors: [],
      messaging,
      
      async requestPermission() {
        try {

          const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
          if (registration.installing) {
            const serviceWorker = registration.installing || registration.waiting;
            
            await new Promise<void>((resolve) => {
              if (serviceWorker.state === 'activated') {
                resolve();
                return;
              }    
              serviceWorker.addEventListener('statechange', (e) => {
                // Type assertion to tell TypeScript this is a ServiceWorker
                const sw = e.target as ServiceWorker;
                if (sw && sw.state === 'activated') {
                  resolve();
                }
              });
            });
          }

          const permission = await Notification.requestPermission();
          
          if (permission === 'granted') {
            // Check if token already exists in local storage
            const existingToken = localStorage.getItem('fcm_token');
            if (existingToken) {
              console.log('Existing FCM Token retrieved:', existingToken);
              return existingToken;
            }   
            // Generate new token
            const token = await getToken(messaging, { 
              vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
              serviceWorkerRegistration: registration,
            });
            
            // Store token in local storage
            if (token) {
              localStorage.setItem('fcm_token', token);
              console.log('New FCM Token generated and stored:', token);
            }
            
            return token;
          } else {
            console.log(`Notification permission denied;${permission}`);
            return null;
          }
        } catch (error) {
          console.error('Error requesting notification permission:', error);
          return null;
        }
      },

      // Method to refresh token if needed
      async refreshToken() {
        try {
          const registration = await navigator.serviceWorker.ready;
          const token = await getToken(messaging, { 
            vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration,
          });

          if (token) {
            localStorage.setItem('fcm_token', token);
            console.log('Token refreshed:', token);
            return token;
          }
        } catch (error) {
          console.error('Error refreshing token:', error);
        }
      },


      onMessageListener() {
        return new Promise((resolve) => {
          onMessage(messaging, (payload) => {
            console.log('Message received:', payload);
            resolve(payload);
          });
        });
      }

    };
  }

  return {
    isCompatible: false,
    errors: ['Not in browser environment'],
    messaging: null,
    requestPermission: () => Promise.resolve(null),
    refreshToken: () => Promise.resolve(null),
    onMessageListener: () => Promise.resolve({}),
  };

};


// Optional: Add a method to clear the stored token
export const clearFCMToken = () => {
  localStorage.removeItem('fcm_token');
};